import title from "global/constants/TitleConstants";
import { useLocation } from "react-router-dom";
import { useTitle } from "utils/UseTitle";
import Step2 from "./components/Step2";
import Step1 from "./components/Step1";
import { useEffect, useState } from "react";
import CenteredAuthenticatedLayout from "layouts/CenteredAuthenticated/CenteredAuthenticatedLayout";
import { Container } from "@mui/material";
import { SubmitSocialCampaign } from "types/Campaign";
import { initialSubmitSocialCampaignFields } from "../Constants";
import { SocialCampaignContext } from "./Context";

const SocialCampaign = () => {
  useTitle(title.CREATE_SOCIAL_CAMPAIGN);
  const urlParams = new URLSearchParams(useLocation().search);
  const campaignId = urlParams.get("id");
  const [submitCampaign, setSubmitCampaign] = useState<SubmitSocialCampaign>(
    initialSubmitSocialCampaignFields() as SubmitSocialCampaign
  );
  const [skipStepOne, setSkipStepOne] = useState<boolean>(false);
  const [managingStep, setManagingStep] = useState<string>("");
  const [socialApps, setSocialApps] = useState([]);
  const [pageDetails, setPageDetails] = useState<any>([]);
  const [pages, setPages] = useState<any>([]);

  useEffect(() => {
    if (campaignId) {
      retrieveCampaignDetails();
    }
  }, [campaignId]);

  const retrieveCampaignDetails = async () => {
    try {
      setSkipStepOne(true);
    } catch (error: any) {}
  };

  const getSteps = () => {
    if (skipStepOne) {
      return <Step2 />;
    } else {
      return <Step1 setSkipStepOne={setSkipStepOne} />;
    }
  };

  return (
    <SocialCampaignContext.Provider
      value={{
        submitCampaign,
        setSubmitCampaign,
        managingStep,
        setManagingStep,
        socialApps,
        setSocialApps,
        pageDetails,
        setPageDetails,
        pages,
        setPages
      }}
    >
      <CenteredAuthenticatedLayout>
        <Container maxWidth="md">{getSteps()}</Container>
      </CenteredAuthenticatedLayout>
    </SocialCampaignContext.Provider>
  );
};

export default SocialCampaign;
